import { Route } from "@angular/router";
import { authGuard } from "@core/guards";
import { AsicInvoicePageComponent } from "./components/asic-invoice-page/asic-invoice-page.component";

export function getAsicInvoicesRoutes(): Route[] {
  return [
    {
      title: 'ASIC Invoice',
      path: 'asic-invoices/:documentId',
      component: AsicInvoicePageComponent,
      canActivate: [authGuard]
    },
  ];
}
